import { render, staticRenderFns } from "./faqs-clientes.vue?vue&type=template&id=4fd47cc6&lang=html"
import script from "./faqs-clientes.vue?vue&type=script&lang=js"
export * from "./faqs-clientes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports